import React from 'react';
import type { Ref, ReactNode } from 'react';

import { styled } from '@backyard-ui/styles';
import type { StitchesCSS } from '@backyard-ui/styles';

import styles from './Container.styles';
export interface ContainerProps {
  /**
   * Define the container size
   */
  size?: 'sm' | 'xs' | 'md' | 'lg' | 'xl';

  /**
   * If true the style width: 100% is
   * applied across all viewports and devices
   */
  isFluid?: boolean;

  /**
   * The ref to the HTML DOM element
   */
  ref?: Ref<HTMLDivElement>;

  /**
   * Stitches `css` func
   */
  css?: StitchesCSS;

  /**
   * The child nodes
   */
  children: ReactNode;
}

const ContainerEl = styled('div', styles);

const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  (props, ref) => {
    return <ContainerEl ref={ref} {...props} />;
  }
);

Container.displayName = 'Container';

export default Container;
